'use client';

import { useRef } from 'react';
import {
  getGlobal,
  isClient,
  isE2E,
  isWorker,
} from '@frameio/utils/config/helpers';
import { log } from '@frameio/utils/log';
import { initDatadog } from './datadog';

export const useBrowserTelemetry = () => {
  const hasInittedBrowserTelemetry = useRef(false);

  /**
   * While sometimes it can be preferable to record telemetry in e2e tests,
   * these services create a lot of network noise, causing Playwright to wait on
   * them, slowing down e2e tests
   */
  if (isE2E()) return;

  try {
    if (!hasInittedBrowserTelemetry.current && (isClient || isWorker)) {
      if (getGlobal().DD_RUM) {
        initDatadog();
      }
    }
  } catch (e) {
    log.error(e);
  }
  hasInittedBrowserTelemetry.current = true;
};
